<template>
  <v-container>
    <Loader :loading="loading" />
      <v-btn color="primary" small class="mr-2" @click="getActivationsList(false)" text>Обновить</v-btn>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Поиск..."
      class="sticky search"
      single-line
      hide-details
      :loading="loadingSearch"
      clearable="true"
    ></v-text-field>
    <v-data-table :headers="headers" :items="activationsList" hide-actions>
      <template slot="headerCell" slot-scope="{ header }">
        <span
          class="subheading font-weight-light text-success text--darken-3"
          v-text="header.text"
        />
      </template>
      <template v-if="item.options" slot="items" slot-scope="{ item }">
        <td class="text-xs-left">{{ item.options.serial_number }}</td>
        <td class="text-xs-left">{{ item.options.code_client }}</td>
        <td class="text-xs-left">
          <span v-if="item.options.product_info">{{item.options.product_info.vendor_code}}</span>
          <span v-else>Товар удален</span>
        </td>
        <td class="text-xs-left">
          <span v-if="item.options.product_info">{{item.options.product_info.name}}</span>
          <span v-else>Товар удален</span>
        </td>
   




        <td class="text-xs-left">
          <small>{{ item.client.phone_number}}</small>
          <br />
          {{ item.client.first_name}} {{ item.client.last_name}}
          <br/>
         
        </td>
        <td>
           <span v-if="item.client.location">{{item.client.location.region.language.title}} {{item.client.location.language.title}} </span>
           <span v-else>Не указан</span>
        </td>
 
        <td class="text-xs-left">
          <span v-if="(item.outlet) && item.outlet.id!==9">{{ item.outlet.title }}</span>
          <span v-else>{{item.address}}</span>
        </td>
        <td class="text-xs-right">{{ item.created_at | dateTime }}</td>
      </template>
    </v-data-table>

    <div class="horizontal-scroll">
      <v-pagination
        v-if="last_page>1"
        v-model="page"
        total-visible="20"
        class="my-4"
        :length="last_page"
      ></v-pagination>
    </div>

    <Dealer />
    <ProductCard />

    <div :class="`products-filters ${(openFilter) ? ' activeNow' : ''}`">
      <div class="products-filters-content">
        <div class="products-filters-content-view date">
          <div>
            <!--<v-radio-group v-model="resourceValue">-->
            <!--<v-radio-->
            <!--v-if="resourceValue"-->
            <!--@change="setResource"-->
            <!--label="Показать все"-->
            <!--color="primary"-->
            <!--value="0"-->
            <!--&gt;</v-radio>-->
            <!--<v-radio-->
            <!--@change="setResource"-->
            <!--v-for="res in resources"-->
            <!--:label="res.name"-->
            <!--color="secondary"-->
            <!--:value="res.id"-->
            <!--&gt;</v-radio>-->
            <!--</v-radio-group>-->
            <div>
              <h4>ДАТА НАЧАЛА</h4>

              <v-date-picker
                :dark="true"
                v-model="start_at"
                :landscape="false"
                locale="ru"
                :color="'primary'"
                :reactive="true"
                :full-width="true"
                :show-current="false"
                :multiple="false"
                :readonly="false"
                :disabled="false"
                @change="setRange"
              ></v-date-picker>
            </div>
            <h4>ДАТА ОКОНАЧАНИЯ</h4>
            <div>
              <v-date-picker
                :dark="true"
                v-model="end_at"
                :landscape="false"
                locale="ru"
                :color="'primary'"
                :reactive="true"
                :full-width="true"
                :show-current="false"
                :multiple="false"
                :readonly="false"
                :disabled="false"
                @change="setRange"
              ></v-date-picker>
            </div>
          </div>
        </div>
      </div>

      <div class="products-filters-control">
        <v-btn @click="clearRange" style="width: 100%" color="danger" class="mb-0" text>Сбросить все</v-btn>

        <v-btn
          style="width: 100%"
          color="primary"
          class="mb-0"
          @click="openFilter=false"
          text
        >Закрыть календарь</v-btn>
      </div>
    </div>

    <v-dialog
      width="400"
      persistent
      transition="dialog-bottom-transition"
      v-model="export_data.length && !loading"
    >
      <v-card>
        <v-card-text>
          <div class="body-2">Выгрузите экспорт</div>
          <br />
          <br />
          <download-excel
            v-if="export_data.length && loading===false"
            :data="export_data"
            :fields="json_fields_all_products"
            :name="'export_' + exportFileName"
          >
            <v-btn color="warning" text style="width:100%">Скачать</v-btn>
          </download-excel>

          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="text-xs-center">
          <v-btn color="primary" text style="width:100%" @click="export_data=[]">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import Loader from "@/components/helper/Loader";

import { mapMutations, mapState } from "vuex";
import Dealer from "@/components/core/Dealer";
import ProductCard from "@/components/core/ProductCard";

export default {
  name: "Activations",
  data: () => ({
    //export
    exportFileName: "",
    json_fields_all_products: {
      "Серийный номер": "serial_number",
      "Наименование товара": "product_name",
      "Секретный код": "secret",
      Артикул: "product_vendor_code",
      "Розыгрышь (акция)": "raffle_name",
      Дилер: "dealer_name",
      "Номер телефона дилера": "dealer_phone",
      Клиент: "client_name",
      "Номер телефона клиента": "client_phone",
      "Место покупки": "outlet_info",
      "Дата активации": "created_at",
      "Адрес покупателя": "location",
    },
    export_data: [],
    //export
    categorySelected: [],
    brandSelected: [],
    raffleSelected: [],
    outletSelected: [],
    outlets: [],
    raffles: [],
    countDay: 0,
    search: "",
    start_at: null,
    end_at: null,
    is_null: false,
    brandFilter: true,
    withdraw: false,
    count: 0,
    page: 1,
    last_page: 0,
    openFilter: false,
    openFilterProduct: false,
    searcher: null,
    loadingSearch: true,
    loading: true,
    headers: [
      {
        sortable: false,
        text: "Серийный номер",
        value: "serial_number"
      },
      {
        sortable: false,
        text: "Секретный ключ",
        value: "code"
      },
      {
        sortable: false,
        text: "Артикул",
        value: "product.vendor_code"
      },
      {
        sortable: false,
        text: "Наименование товара",
        value: "product.title"
      },
    
      {
        sortable: false,
        text: "Покупатель",
        value: "dealer.title"
      },
      {
        sortable: false,
        text: "Адрес покупателя",
        value: "dealer.title"
      },
    
      {
        sortable: false,
        text: "Место покупки",
        value: "dealer.phone_number"
      },
      {
        sortable: false,
        text: "Дата активации",
        value: "created_at",
        align: "right"
      }
    ],
    activationsList: []
  }),
  components: { ProductCard, Dealer, Loader },
  methods: {
    ...mapMutations(["SET_USER", "SET_BADGE_ACTIVATIONS", "SET_PRODUCT_CARD"]),
    getActivationsList(noLoading) {


      let vendorSet = null;
      
      if (this.brand) {
          vendorSet =  Object.keys(this.brand).join("-");
          if (vendorSet){
            this.brandFilter = false;
          }
      }



      if (!noLoading) this.loading = true;
      axios
        .get("admin/activations-client", {
          params: {
            per_page: 15,
            page: this.page,
            search: this.search,
            start_at: this.start_at,
            end_at: this.end_at,
            category_id: this.selectedCategory,
               brand_id: (vendorSet) ? vendorSet : this.selectedBrand,
            raffle_id: this.selectedRaffle,
            outlet_id: this.selectedOutlet
          }
        })
        .then(response => {
          this.SET_BADGE_ACTIVATIONS(0);
          this.activationsList = response.data.data;
          this.last_page = response.data.last_page;
          this.count = response.data.total;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
          this.loadingSearch = false;
        });
    },
    getRaffleList() {
      axios
        .get("raffles/list/all")
        .then(response => {
          this.raffles = response.data;
          console.log(this.raffles);
        })
        .catch(error => {})
        .finally(() => {});
    },
    getOutletList() {
      axios
        .get("outlets")
        .then(response => {
          this.outlets = response.data;
        })
        .catch(error => {})
        .finally(() => {});
    },

    setRange() {
      this.page = 1;
      setTimeout(() => {
        this.getActivationsList();
      }, 300);
    },
    clearRange() {
      this.withdraw = this.is_null = false;
      this.page = 1;
      this.search = "";
      this.start_at = this.end_at = null;
      this.countDay = 0;
      this.categorySelected = [];
      this.brandSelected = [];
      this.outletSelected = [];
      this.raffleSelected = [];
      setTimeout(() => {
        this.getActivationsList();
      }, 300);
    },
    setDay() {
      this.page = 1;
      setTimeout(() => {
        let now = new Date(Date.now());
        let today = this.setZero(now.getDate());
        let month = this.setZero(now.getMonth() + 1);
        let year = now.getFullYear();
        if (!this.countDay) {
          this.countDay = 0;
        }
        let endDate = Date.now() - this.countDay * 24 * 3600 * 1000;
        let startNow = new Date(endDate);
        let todayNow = this.setZero(startNow.getDate());
        let monthNow = this.setZero(startNow.getMonth() + 1);
        let yearNow = startNow.getFullYear();
        this.start_at = yearNow + "-" + monthNow + "-" + todayNow;
        this.end_at = year + "-" + month + "-" + today;
      }, 20);

      setTimeout(() => {
        this.getActivationsList();
      }, 300);
    },

    setIsNull() {
      this.page = 1;
      setTimeout(() => {
        this.getActivationsList();
      }, 300);
    },

    setWithdraw() {
      this.page = 1;
      setTimeout(() => {
        this.getActivationsList();
      }, 300);
    },

    setData() {
      this.page = 1;
      this.search = "";
      setTimeout(() => {
        this.getActivationsList();
      }, 300);
    },

    setZero(val) {
      if (val <= 9) {
        val = "0" + val;
      }
      return val;
    },
    unsetZero(item) {
      this.$dialog
        .confirm("Вы точно хотите изменить награду и применить новую?", {
          okText: "Да, хочу",
          cancelText: "Отмена"
        })
        .then(() => {
          this.loading = true;
          axios
            .put("admin/activations/set-zero", {
              option_id: item.option_id,
              dealer_id: item.dealer_id
            })
            .then(response => {
              this.$toast.success({
                title: "Успешно обновили бонус",
                message: "Пользователь получил новую сумму"
              });
            })
            .catch(error => {
              this.$toast.error({
                title: "Ошибка",
                message: "Отправьте сериный номер товара администратору сайта"
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.getActivationsList();
              }, 100);
            });

          this.tg({
            object: "#ativationsChangeReward",
            id: item.option_id,
            serial_number: item.serial_number,
            reward: item.reward,
            new_reward: item.new_reward
          });
        })
        .catch(() => {});
    },
    tg(obj) {
      let message = JSON.stringify(obj);
      axios.post("notify/telegram", {
        message: message
      });
    },

    openExport() {
      this.exportFileName = "activations_client.xls";
      this.loading = true;


      let vendorSet = null;
         if (this.brand) {
          vendorSet =  Object.keys(this.brand).join("-");
          if (vendorSet){
            this.brandFilter = false;
          }
      }

      setTimeout(() => {
         axios
          .get("admin/export/activations-client", {
            params: {
              search: this.search,
              start_at: this.start_at,
              end_at: this.end_at,
              category_id: this.selectedCategory,
            brand_id: (vendorSet) ? vendorSet : this.selectedBrand,
              raffle_id: this.selectedRaffle,
              outlet_id: this.selectedOutlet
            }
          })
          .then( async response => {
             this.export_data = await response.data;
          })
          .catch(error => {})
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
            }, 3000);
          });
      }, 100);
    }
  },
  mounted() {
    this.getRaffleList();
    this.getOutletList();
    this.getActivationsList();
  },
  computed: {
    ...mapState(["categories", "brands", "brand"]),
    selectedCategory: {
      get() {
        if (this.categorySelected.length) {
          let category = [];
          for (let i = 0; i < this.categorySelected.length; i++) {
            category.push(this.categorySelected[i].id);
          }
          return category.length ? category.join("-") : "";
        }
        return "";
      }
    },
    selectedBrand: {
      get() {
        if (this.brandSelected.length) {
          let brand = [];
          for (let i = 0; i < this.brandSelected.length; i++) {
            brand.push(this.brandSelected[i].id);
          }
          return brand.length ? brand.join("-") : "";
        }
        return "";
      }
    },
    selectedRaffle: {
      get() {
        if (this.raffleSelected.length) {
          let raffle = [];
          for (let i = 0; i < this.raffleSelected.length; i++) {
            raffle.push(this.raffleSelected[i].id);
          }
          return raffle.length ? raffle.join("-") : "";
        }
        return "";
      }
    },
    selectedOutlet: {
      get() {
        if (this.outletSelected.length) {
          let outlet = [];
          for (let i = 0; i < this.outletSelected.length; i++) {
            outlet.push(this.outletSelected[i].id);
          }
          return outlet.length ? outlet.join("-") : "";
        }
        return "";
      }
    }
  },
  watch: {
    search() {
      this.loadingSearch = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.page = 1;
        this.getActivationsList(true);
      }, 1000);
    },
    page() {
      setTimeout(() => {
        this.getActivationsList();
      }, 300);
    }
  }
};
</script>
